module.exports = __webpack_public_path__ + "static/media/Jenny Dudikoff Headshot.ef5f42d7.jpg";